/** Response/Data Model for External Service */
export interface ExternalServiceData {
  applicationId?: number;
  lenderCode: string;
  url: string;
  requestData: string;
  responseData: string;
  exception: string;
  statusTypeId: StatusType;
  integrationTypeId: number;
}

/** External Service Response Status Type */
export enum StatusType {
  Success = 1,
  Fail
}

/** Logging Type */
export enum IntegrationType {
  DX_Alloy_CreateJourneyApplication = 95,
  DX_Alloy_UpdateJourneyApplication = 96,
  DX_Alloy_GetJourneyApplication = 97,
  DX_Alloy_RerunJourneyApplication = 98,
  DX_Alloy_StepupVerification = 99
}
